import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { getUserCampaigns, authenticateUsername, verifyPassword, clearCampaigns, clearError } from '@/features/auth/authSlice'

import './LoginPage.css'
import AuthLayout from './components/AuthLayout'
import LoginForm from './components/LoginForm'
import CampaignSelect from './components/CampaignSelect'

const LoginPage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { isAuthenticated, campaigns } = useSelector((state) => state.auth)

    const [step, setStep] = useState('credentials') // 'credentials' | 'campaigns'
    const [pendingPassword, setPendingPassword] = useState('')

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard')
        }
    }, [isAuthenticated, navigate])

    useEffect(() => {
        dispatch(clearError())
    }, [dispatch])

    const handleLoginSubmit = async (formData) => {
        try {
            const campaigns = await dispatch(getUserCampaigns(formData.username)).unwrap()
            setPendingPassword(formData.password)

            if (campaigns.length === 1) {
                await handleCampaignSelect(campaigns[0], formData.password)
            } else {
                setStep('campaigns')
            }
        } catch (error) {
            console.error('Fetching campaigns failed:', error)
        }
    }

    const handleCampaignSelect = async (campaign, password = pendingPassword) => {
        try {
            const userData = await dispatch(authenticateUsername({
                campaignid: campaign.campaignid,
                userid: campaign.userid,
            })).unwrap()

            if (userData.isfirstlogin) {
                navigate('/verify-otp')
                return
            }

            await dispatch(verifyPassword({
                userid: campaign.userid,
                password,
                campaignid: campaign.campaignid,
            }))
        } catch (error) {
            console.error('Authentication failed:', error)
        }
    }

    const handleBackToCredentials = () => {
        setPendingPassword('')
        dispatch(clearCampaigns())
        setStep('credentials')
    }

    const handleForgotPassword = () => {
        navigate('/reset-password')
    }

    const imageText = (
        <>
            <div className="login-image-text-wrapper">
                Recognise <span className="highlight-text">Achievements.</span>
            </div>
            <div className="login-image-text-wrapper">
                Reward <span className="highlight-text">Performance.</span>
            </div>
        </>
    )

    return (
        <AuthLayout showImage imageText={imageText}>
            {step === 'campaigns' ? (
                <CampaignSelect
                    campaigns={campaigns}
                    onSelect={handleCampaignSelect}
                    onBack={handleBackToCredentials}
                />
            ) : (
                <LoginForm
                    onSubmit={handleLoginSubmit}
                    onForgotPassword={handleForgotPassword}
                />
            )}
        </AuthLayout>
    )
}

export default LoginPage

